export default "__VITE_ASSET__63ef6f13__"